



















































































































































































































































































































































































































































































import { APIReport } from '@/models/api/report.model'
import { Vue, Component, Watch } from 'vue-property-decorator'
import { ADMColumn } from '@/interfaces/adm-columns.interface'
import { APIPagination } from '@/models/api/pagination.model'
import { FieldName } from '../../../interfaces/field-name.interface'
import moment from 'moment'
import { APIProduct } from '@/models/api/product.model'
import { APIProvider } from '@/models/api/provider.model'
import { APICarrier } from '@/models/api/carrier.model'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

@Component({
    components: {
        ConfirmDialog
    }
})
export default class ReportView extends Vue {
  chartEnabled = false;
  chartType = '';
  exportSelection = '';

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chartData: any = [];

  actions = [
      { text: 'Alta', value: 'created_at' },
      { text: 'Baja', value: 'deactivated_at' },
      { text: 'Todo', value: 'all' }
  ];

  chartOptions = {
      height: 600,
      title: '',
      curveType: 'function',
      colorAxis: { colors: ['#E7711C', '#4374E0'] },
      datalessRegionColor: '#ccc',
      is3D: false,
      backgroundColor: {
          fill: '#363636',
          opacity: 100
      },
      titleTextStyle: {
          fontSize: 14,
          color: 'white'
      },
      legend: {
          textStyle: {
              fontSize: 12,
              color: 'white'
          },
          position: 'top'
      },
      tooltip: {
          textStyle: {
              fontSize: 12,
              color: 'black'
          }
      },
      vAxis: {
          textStyle: {
              fontSize: 12,
              color: 'white'
          },
          gridlines: {
              color: '#F4F4F4'
          },
          baselineColor: '#F4F4F4',
          minValue: 0
      },
      hAxis: {
          textStyle: {
              fontSize: 12,
              color: 'white'
          },
          gridlines: {
              color: '#F4F4F4'
          },
          baselineColor: '#F4F4F4'
      }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formDataFilter: { [key: string]: any } = {};
  loadingFilter = false
  addFilter = false;
  buttonLoading = false;
  buttonLoadingFilter = false;
  loading = false;
  loadingTable = false;
  loadingDownloadFile = false;
  mainTitle = '';
  reportData: APIReport;
  reportFilters: FieldName[] = [];
  menu = [];
  formValid = false;
  formValidFilter = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formData: { [key: string]: any } = {};

  formRules = {
      required: [(v: string) => !!v || 'This field is required'],
      onlyNumbers: [
          (v: string) => !!v || 'This field is required',
          (v: string) => {
              const pattern = /^[0-9]*$/
              return pattern.test(v) || 'This field accept only numbers'
          }
      ]
  };

  now = moment().format('YYYY-MM-DD').toString();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: object[] = [];
  users: object[] = [];

  colNames: ADMColumn[] = [];
  customColums: ADMColumn[] = [];
  colNamesFilters: ADMColumn[] = [
      { text: 'Id', value: 'reportUserFilterId' },
      { text: 'Filter Name', value: 'reportUserFilterName' },
      {
          text: 'Actions',
          width: '100px',
          customField: {
              type: 'options',
              hideAll: false
          }
      }
  ];

  showTableFilters = false;
  showTable = false;
  selectRows = false;
  rowsPerPage = 15;
  selectedRows = [];
  pagination: APIPagination = {
      currentPage: 1,
      total: 0,
      nextPage: null,
      previousPage: null
  };

  carriersList: APICarrier[] = [];
  carriers: object[] = [];
  nameCarriers: object[] = [];

  providersList: APIProvider[] = [];

  providers: object[] = [];
  providerChilds: object[] = [];
  nameProviders: object[] = [];
  nameProviderChilds: object[] = [];
  products: object[] = [];
  productChilds: object[] = [];
  nameProducts: object[] = [];
  nameProductChilds: object[] = [];
  itemFilters: object[] = [];

  confirmDialogTrigger = false;
  confirmDialogData = null;

  @Watch('pagination.currentPage', { deep: true })
  paginationHandler () {
      this.$vuetify.goTo('#my-table')
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createChart (el: any, google: any, type: string) {
      let chart
      switch (type) {
      case 'PieChart':
          chart = new google.visualization.PieChart(el)
          break
      case 'LineChart':
          chart = new google.charts.Line(el)
          break
      case 'BarChart':
          chart = new google.charts.Bar(el)
          break
      case 'ColumnChart':
          // chart = new google.charts.Bar(el)
          chart = new google.visualization.ColumnChart(el)
          break
      case 'AreaChart':
          chart = new google.charts.Area(el)
          break
      case 'GeoChart':
          chart = new google.charts.Geo(el)
          break
      case 'Gauge':
          chart = new google.charts.Gauge(el)
          break
      case 'Table':
          chart = new google.charts.Table(el)
          break
      case 'Timeline':
          chart = new google.charts.Timeline(el)
          break
      }
      return chart
  }

  parseQueryValue (queryValue: string) {
      const query = queryValue.replace('?', '')
      return query
  }

  validRequiredField (fieldName: string) {
      return !fieldName.includes('?') ? this.formRules.required : []
  }

  isDate (text: string) {
      if (text && text.length > 0) {
          const valid = this.getDateFormat(text)
          if (
              !valid.includes('NaN') &&
        text &&
        text.includes('T') &&
        text.includes('Z')
          ) {
              return true
          }
      }
      return false
  }

  dateFormat (text: string) {
      if (this.isDate(text)) {
          text = moment(`${text}`).format('DD/MM/YYYY HH:mm')
      }
      return text
  }

  getDateFormat (dateString: string) {
      const date = new Date(dateString)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear().toString().padStart(4, '0')
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      return `${day}/${month}/${year} ${hours}:${minutes}`
  }

  downloadFile () {
      this.loadingDownloadFile = true
      switch (this.exportSelection) {
      case 'CSV':
          this.$store
              .dispatch('exportReportCsv', {
                  reportId: this.$route.params.reportId,
                  reportFilters: this.reportFilters
              })
              .then((resp) => {
                  if (resp?.status === 200) {
                      this.$store.commit('reportSuccess', 'Done Successfully!')
                      const csvContent = 'data:text/csv;charset=utf-8,' + resp.data
                      const encodedUri = encodeURI(csvContent)
                      const link = document.createElement('a')

                      link.setAttribute('href', encodedUri)
                      link.setAttribute(
                          'download',
                          `${this.reportData.reportName} - ${this.getDateFormat(
                              new Date().toString()
                          )}.csv`
                      )
                      document.body.appendChild(link)
                      link.click()
                  }
                  this.loadingDownloadFile = false
              })
          break

      default:
          this.$store.commit('reportError', {
              code: 1000,
              message: 'Export to is a required'
          })
          this.loadingDownloadFile = false
          break
      }
  }

  get userData () {
      return this.$store.state.AuthStore.auth.user
  }

  getData () {
      this.loading = true
      if (!this.$route.params.reportId) {
          this.$store.commit('reportError', {
              code: 1000,
              message: 'Error, not id sended in route params :('
          })
          this.loading = false
          return
      }
      this.$store
          .dispatch('getReportsById', this.$route.params.reportId)
          .then((resp) => {
              if (resp?.status === 200) {
                  this.reportData = this.$store.state.ReportsStore.reportForm
                  this.mainTitle = this.reportData.reportName
                  this.loading = false
                  if (this.reportData.reportChartEnabled) {
                      this.chartEnabled = true
                  }
              }
          })
  }

  getProducts () {
      return new Promise((resolve) => {
          this.$store
              .dispatch('getMonitorProductsFilter', {
                  carrierId: undefined,
                  providerId: undefined
              })
              .then((resp) => {
                  if (resp.status === 200) {
                      this.products = this.$store.state?.ProductsStore?.products?.map(
              (p: APIProduct) => {
                  return {
                      text: p.productName,
                      value: p.productId
                  }
              }
            )
                      this.nameProducts = this.$store.state?.ProductsStore?.products?.map(
              (p: APIProduct) => {
                  return {
                      text: p.productName,
                      value: p.productName
                  }
              }
            )
                      resolve()
                  }
              })
      })
  }

  getUsers () {
      this.loadingFilter = true
      return new Promise((resolve) => {
          this.$store
              .dispatch('getUsersFilter')
              .then((resp) => {
                  if (resp.status === 200) {
                      this.users = this.$store.state?.FiltersStore?.usersFilter?.map(
                        (p: {username: string; userId: number}) => {
                            return {
                                text: p.username,
                                value: p.userId
                            }
                        })
                      this.loadingFilter = false
                      resolve(resp)
                  }
              })
      })
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getProvidersByCarrier (filter: any, existChild: boolean) {
      return new Promise<void>((resolve) => {
          const carrier = this.carriersList.find(
              (x) => (x.carrierId === filter.paramValue || x.carrierName === filter.paramValue)
          )
          if (carrier && existChild) {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              const carrierId: any = carrier?.carrierId

              this.$store
                  .dispatch('getMonitorProvidersFilter', {
                      carrierId: carrierId
                  })
                  .then((resp) => {
                      if (resp.status === 200) {
                          this.providerChilds = resp.data.map((p: APIProvider) => {
                              return {
                                  text: p.providerName,
                                  value: p.providerId
                              }
                          })
                          this.nameProviderChilds = resp.data.map((p: APIProvider) => {
                              return {
                                  text: p.providerName,
                                  value: p.providerName
                              }
                          })
                          this.productChilds = []
                          this.nameProductChilds = []
                          resolve()
                      }
                  })
          }
      })
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getProductsByProvider (filter: any, existChild: boolean) {
      return new Promise((resolve) => {
          const provider = this.providersList.find(
              (x) => (x.providerId === filter.paramValue || x.providerName === filter.paramValue)
          )
          if (provider && existChild) {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              const carrierId: any = provider?.carrierId

              this.$store
                  .dispatch('getMonitorProductsFilter', {
                      carrierId: carrierId.carrierId,
                      providerId: provider?.providerId
                  })
                  .then((resp) => {
                      if (resp.status === 200) {
                          this.productChilds = resp.data.map((p: APIProduct) => {
                              return {
                                  text: p.productName,
                                  value: p.productId
                              }
                          })
                          this.nameProductChilds = resp.data.map((p: APIProduct) => {
                              return {
                                  text: p.productName,
                                  value: p.productName
                              }
                          })
                          resolve()
                      }
                  })
          }
      })
  }

  getProviders () {
      return new Promise((resolve) => {
          this.$store
              .dispatch('getMonitorProvidersFilter', {
                  carrierId: this.userData.carrierId?.carrierId
              })
              .then((resp) => {
                  if (resp.status === 200) {
                      const provider = this.$store.state.AuthStore.auth.user.providerId
                      if (provider && provider.providerId) {
                          this.providersList = [provider]
                          this.providersList.forEach(
                              (provider: { providerId: number; providerName: string }) => {
                                  this.providers.push({
                                      text: provider.providerName,
                                      value: provider.providerId
                                  })
                                  this.nameProviders.push({
                                      text: provider.providerName,
                                      value: provider.providerName
                                  })
                                  this.providerChilds.push({
                                      text: provider.providerName,
                                      value: provider.providerName
                                  })
                              }
                          )
                      } else {
                          this.providersList = resp.data
                          resp.data.forEach(
                              (provider: { providerId: number; providerName: string }) => {
                                  this.providers.push({
                                      text: provider.providerName,
                                      value: provider.providerId
                                  })
                                  this.nameProviders.push({
                                      text: provider.providerName,
                                      value: provider.providerName
                                  })
                                  this.providerChilds.push({
                                      text: provider.providerName,
                                      value: provider.providerName
                                  })
                              }
                          )
                      }
                      resolve()
                  }
              })
      })
  }

  getCarriers () {
      return new Promise<void>((resolve) => {
          this.$store
              .dispatch('getCarriers')
              .then((resp) => {
                  if (resp.status === 200) {
                      const carrier = this.$store.state.AuthStore.auth.user.carrierId

                      if (carrier && carrier.carrierId) {
                          this.carriersList = [carrier]
                      } else {
                          this.carriersList = resp.data
                      }
                      this.carriersList.forEach(
                          (carrier: { carrierId: number; carrierName: string }) => {
                              this.carriers.push({
                                  text: carrier.carrierName,
                                  value: carrier.carrierId
                              })
                              this.nameCarriers.push({
                                  text: carrier.carrierName,
                                  value: carrier.carrierName
                              })
                          }
                      )
                      resolve()
                  }
              })
      })
  }

  getFilters () {
      this.loading = true
      this.$store
          .dispatch('getReportFilters', this.$route.params.reportId)
          .then((resp) => {
              if (resp?.status === 200) {
                  this.reportFilters = resp.data
                  if (this.reportFilters.length === 0) {
                      this.viewReport()
                  } else {
                      this.getFilterUser()
                  }
              }
              this.loading = false
          })
  }

  confirmedDialog (callback: { [key: string]: string | number | boolean }) {
      this.$store
          .dispatch('deleteUserFilter', callback.reportUserFilterId)
          .then((resp) => {
              if (resp?.status === 200) {
                  this.$store.commit('reportSuccess', 'Done Successfully!')
                  this.getFilterUser()
              }
          })
  }

  async validateForm () {
      await (
      this.$refs.formFilter as Vue & { validate: () => boolean }
      ).validate()
      if (!this.formValidFilter) return

      this.buttonLoadingFilter = true

      const user = this.$store.state.AuthStore.auth.user
      this.$store
          .dispatch('createReportUserFilter', {
              reportId: this.$route.params.reportId,
              userId: user.userId,
              reportUserFilterName: this.formDataFilter.reportUserFilterName,
              reportUserFilterData: JSON.stringify(this.reportFilters)
          })
          .then(async (resp) => {
              if (resp?.status === 200) {
                  this.$store.commit('reportSuccess', 'Done Successfully!')
                  this.addFilter = false
                  this.formDataFilter.reportUserFilterName = ''
                  this.getFilterUser()
              }
              this.buttonLoadingFilter = false
          })
  }

  getFilterUser () {
      const user = this.$store.state.AuthStore.auth.user
      this.$store
          .dispatch('getReportUserFilter', {
              reportId: this.$route.params.reportId,
              userId: user.userId
          })
          .then((resp) => {
              if (resp?.status === 200) {
                  this.itemFilters = resp.data
                  this.showTableFilters = true
                  this.colNamesFilters.forEach((column) => {
                      if (column.customField) this.customColums.push(column)
                  })
              }
          })
  }

  resetFilters () {
      this.colNames = []
      this.items = []
      this.reportFilters.map((item) => {
          item.paramValue = ''
      })
      this.showTable = false
  }

  existFilter (filterName: string) {
      const filter = this.reportFilters.filter((x) => x.realValue === filterName)
      return !!filter
  }

  async saveReportFilters () {
      if (this.reportFilters.length > 0) {
          await (this.$refs.form as Vue & { validate: () => boolean }).validate()
          if (!this.formValid) return
      }

      this.addFilter = true
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async viewReportWithFilter (item: any) {
      this.loadingTable = true
      const reportFilters = JSON.parse(item.reportUserFilterData)
      this.$store
          .dispatch('viewReport', {
              reportId: this.$route.params.reportId,
              reportFilters: reportFilters
          })
          .then((resp) => {
              if (resp?.status === 200) {
                  if (resp.data.query.length > 0) {
                      this.items = resp.data.query
                      this.chartData = []
                      this.colNames = []
                      const key = Object.keys(this.items[0])
                      this.chartData.push(key)
                      this.items = this.items.map((elemet) => {
                          let data = Object.values(elemet)
                          data = data.map((value) => {
                              const valid = this.isDate(value)
                              if (valid) {
                                  value = moment(`${value}`).format('YYYY-MM-DD HH:mm')
                              }
                              const regex = /((\d+)((\.\d{1,2})?))$/
                              if (value && value.length > 0 && value.match(regex) && !valid) {
                                  value = parseFloat(value)
                              }
                              return value
                          })
                          if (Object.keys(elemet)[1] === 'count(*)') {
                              if (data.filter((x) => x === null).length === 0) {
                                  this.chartData.push(data)
                              }
                          } else {
                              this.chartData.push(data)
                          }

                          return elemet
                      })
                      const cols = Object.keys(resp.data.query[0])
                      cols.map((item) => {
                          this.colNames.push({ text: `${item}`, value: `${item}` })
                      })
                      this.showTable = true
                  } else {
                      this.colNames = []
                      this.items = []
                      this.$store.commit('reportError', {
                          code: 1000,
                          message: 'No data available'
                      })
                  }
                  this.loadingTable = false
              } else {
                  throw resp
              }
          })
          .catch(() => {
              this.loadingTable = false
          })
  }

  async viewReport () {
      if (this.reportFilters.length > 0) {
          await (this.$refs.form as Vue & { validate: () => boolean }).validate()
          if (!this.formValid) return
      }

      this.loadingTable = true

      this.$store
          .dispatch('viewReport', {
              reportId: this.$route.params.reportId,
              reportFilters: this.reportFilters
          })
          .then((resp) => {
              if (resp?.status === 200) {
                  if (resp.data.query.length > 0) {
                      this.items = resp.data.query
                      this.chartData = []
                      this.colNames = []
                      const key = Object.keys(this.items[0])
                      this.chartData.push(key)
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      this.items = this.items.map((elemet) => {
                          let data = Object.values(elemet)
                          data = data.map((value) => {
                              const valid = this.isDate(value)
                              if (valid) {
                                  value = moment(`${value}`).format('YYYY-MM-DD HH:mm')
                              }
                              const regex = /((\d+)((\.\d{1,2})?))$/
                              if (value && value.length > 0 && value.match(regex) && !valid) {
                                  value = parseFloat(value)
                              }
                              return value
                          })
                          if (Object.keys(elemet)[1] === 'count(*)') {
                              if (data.filter((x) => x === null).length === 0) {
                                  this.chartData.push(data)
                              }
                          } else {
                              this.chartData.push(data)
                          }

                          return elemet
                      })

                      const cols = Object.keys(resp.data.query[0])
                      cols.map((item) => {
                          this.colNames.push({ text: `${item}`, value: `${item}` })
                      })
                      this.showTable = true
                  } else {
                      this.$store.commit('reportError', {
                          code: 1000,
                          message: 'No data available'
                      })
                      this.colNames = []
                      this.items = []
                  }
                  this.loadingTable = false
              } else {
                  throw resp
              }
          })
          .catch(() => {
              this.loadingTable = false
          })
  }

  async mounted () {
      this.getData()
      this.getFilters()
      this.getProviders()
      this.getProducts()
      this.getCarriers()
      this.getUsers()
  }
}
